import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrl + 'reviews';

@Injectable({
    providedIn: 'root'
})
export class ReviewsService {
    constructor(private http: HttpClient) { }

    getReviewsList(query): Observable<any> {
        return this.http.get(API_URL + query);
    }

    getReviewsDetails(id): Observable<any> {
        return this.http.get(API_URL + "/" + id);
    }

    updateReviews(id, data): Observable<any> {
        return this.http.put(API_URL + '/' + id, data);
    }

    addReviews(data): Observable<any> {
        return this.http.post(API_URL + '', data);
    }

    getAllReviews(querystring): Observable<any> {
        return this.http.get(API_URL + "/all/?" + querystring);
    }
}
